import React from 'react';
import { Maybe } from '../../graphql/schema/p4types';

export type CommentRowContextType = {
  selectRow: (rowIdx: number) => void;
  addCommentToRowIdx: Maybe<number>;
  dataIdPrefix?: string;
  getDataId?: ({ idx }: { idx: number }) => Maybe<string>;
  allowCommentsForRow?: (rowProps: any) => boolean;
  enableSnippets?: boolean;
};

const CommentRowContext = React.createContext({} as CommentRowContextType);
export default CommentRowContext;
